export default {
  'Difficulty level': '难度级别',
  'Your bet': '赌注',
  'Start game': '开始游戏',
  'Take prize': '收取',
  'Try again': '再试一次',
  Bet: '赌注',
  Profit: '獲利',
};
